module.exports = __webpack_public_path__ + "img/portrait-034.135e722e.jpg";